import React, { useEffect } from 'react';
import { ErrorPage } from '@src/shared/ui';
import { useErrorState, useGTM } from '@src/shared/hooks';
import { GTMEvents } from '@src/config/gtm';

export const ErrorDefaultPage: React.FC = () => {
  const { error, etapa } = useErrorState();
  const { trackEvent } = useGTM();

  useEffect(() => {
    trackEvent(GTMEvents.API_ERROR, {
      etapa,
      origin_error: error,
    });
  }, [error, etapa, trackEvent]);

  return (
    <ErrorPage
      title='Ops, algo deu errado'
      description='Não conseguimos concluir sua solicitação no momento. Por favor, tente novamente ou refaça o seu parcelamento daqui a alguns minutos.'
      backToGolButtonPrimary
    />
  );
};
